import {API} from "./API";
import {InvoiceItem} from "../models/InvoiceItem";

export class InvoiceItemsAPI extends API<InvoiceItem> {

	constructor (invoiceId: string) {
		const endpoint: string = 'invoices/' + invoiceId + '/items';
		super(endpoint)
	}

}
